import { navigate } from "../../../../service/navigation/Navigation";
import { appRoutes } from "../../../../routes/routes";
import ApiUrls from "../../../../service/api/ApiUrls";
import ApiService from "../../../../service/api/ApiService";
import { SignupSocialParamType } from "./SignupPersonalInformationContextProvider";
import ShowToast from "../../../../widget/common/ui/Toast";
import {
  SignupModel,
  SignupResult,
} from "../../../../model/onboarding/signup/SignupModel";

const SignupPersonalInformationProvider =
  new (class SignupPersonalInformationProvider {
    navigateNext = () => {
      navigate(appRoutes.routeNameSignupVerification, { replace: true });
    };

    submitPersonalInfoAPI = async (params: {
      first_name: string;
      last_name: string;
      email: string;
      password: string;
      mobile_code_id: string;
      mobile_no: string;
      city_id: string;
      social: SignupSocialParamType;
    }): Promise<SignupResult | null> => {
      ApiUrls.init();

      const url: string = `${ApiUrls.baseUrl}profile/signup`;
      const body: any = {
        first_name: params.first_name,
        last_name: params.last_name,
        email: params.email,
        password: params.password,
        mobile_code_id: params.mobile_code_id,
        mobile_no: params.mobile_no,
        city_id: params.city_id,
        social_media_params: params.social,
      };

      const response: any = await ApiService.postApi(url, body);
      if (response != null) {
        if (response["success"] === "1") {
          const settingsPersonalInfoModel: SignupModel = response;
          const signupResult: SignupResult =
            settingsPersonalInfoModel?.result?.signup_result!;

          return signupResult;
        } else {
          ShowToast.error(response["errorMessage"]);
        }
      }

      return null;
    };
  })();

export default SignupPersonalInformationProvider;
